import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/cgx-user/login1",
    method: "post",
    data
  });
}

export function getInfo(token) {
  return request({
    url: "/vue-element-admin/user/info",
    method: "get",
    params: { token }
  });
}
